<div class="profile-picture">
  <!--img *ngIf="url" width=300 height=300 src="{{url}}" / -->
<img *ngIf="img_data && url" width=300 height=400 src="data:image/jpeg;base64,{{img_data}}" />
  <label *ngIf="editmode" for="uploader-input" ng2FileDrop [ngClass]="{'drag-over': hasDragOver}" (fileOver)="fileOver($event)" [uploader]="uploader">
    <div class="infotext"><span *ngIf="!url" >Drop your picture<br>or click to upload</span></div>
  </label>
  <input *ngIf="editmode" type="file" ng2FileSelect [uploader]="uploader" id="uploader-input" style="display:none" />
  
</div>
